import React, { useRef, useEffect, useState, useImperativeHandle } from 'react';
import { UseSurveyFormatReturn, UseFormatViewReturn, UseActiveViewReturn } from '../types';

export default function useFormatView<T extends HTMLElement = HTMLElement>(
  name: string,
  formatContext: UseSurveyFormatReturn,
  active: UseActiveViewReturn['active'],
  forwardedRef?: React.Ref<T>
): UseFormatViewReturn<T> {
  const { register, unregister } = formatContext;

  const ref = useRef<T>(null);
  useImperativeHandle(forwardedRef, () => (ref?.current as T) || {});

  const [isActive, setIsActive] = useState(false);
  useEffect(() => setIsActive(active?.ref === ref), [active, ref]);

  React.useEffect(() => {
    register(name, ref);
    return () => unregister(name);
  }, [name, ref, register, unregister]);

  return { ref, isActive };
}
